<template>
  <div style="margin-top: 30px; padding: 11px;">
    <div class="company-details-container">
      <div class="company-details-header">
        <h1>Firma Bilgileri</h1>
        <span @click="toggleCompanyInfo" class="arrow-icon" :class="{'open': showCompanyInfo}">&#x25BC;</span>
        <hr>
      </div>
      <div v-if="showCompanyInfo" class="company-details-content">
        <div v-if="companiesData && Object.keys(companiesData).length" class="company-info">
          <div>
            <div class="info-item">
              <strong>Firma Adı:</strong> {{ companiesData.companyName || 'Bilgi Yok' }}
            </div>
            <div class="info-item">
              <strong>Firma Sicil No:</strong> {{ companiesData.companyRegistrationNumber || 'Bilgi Yok' }}
            </div>
            <div class="info-item">
              <strong>Firma Durumu:</strong>
              <div style="display:inline;" v-show="companiesData.companyDetails[0]?.companyClass === 'ACTIVE'"> Aktif</div>
              <div style="display:inline;" v-show="companiesData.companyDetails[0]?.companyClass === 'INACTIVE'"> Pasif</div>
              <div style="display:inline;" v-show="companiesData.companyDetails[0]?.companyClass === 'POTENTIAL'"> Potansiyel</div>
              <div style="display:inline;" v-show="!companiesData.companyDetails[0]?.companyClass"> Bilgi Yok</div>
            </div>
            <div class="info-item">
              <strong>Çalışan Sayısı:</strong> {{ companiesData.companyDetails[0]?.companyEmployeesCount || 'Bilgi Yok' }}
            </div>
            <div class="info-item">
              <strong>Tehlike Sınıfı:</strong>
              <div style="display:inline;" v-show="companiesData.companyDetails[0]?.companyHazardLesson === 'LESS_DANGEROUS'"> Az Tehlikeli</div>
              <div style="display:inline;" v-show="companiesData.companyDetails[0]?.companyHazardLesson === 'MANY_DANGEROUS'"> Çok Tehlikeli</div>
              <div style="display:inline;" v-show="companiesData.companyDetails[0]?.companyHazardLesson === 'DANGEROUS'"> Tehlikeli</div>
              <div style="display:inline;" v-show="!companiesData.companyDetails[0]?.companyHazardLesson"> Bilgi Yok</div>
            </div>
            <div class="info-item">
              <strong>Sektör:</strong> {{ companiesData.companyDetails[0]?.companySector || 'Bilgi Yok' }}
            </div>
            <div class="info-item">
              <strong>Temsilci Adı:</strong> {{ companiesData.customerRepresentativeUserId?.name || 'Bilgi Yok' }}
            </div>
          </div>
          <hr>

          <div v-if="companiesData.companyOfficials.length" class="info-card">
            <div class="company-details-header">
              <h1>Firma Yetkililileri</h1>
              <span @click="toggleCompanyOfficials" class="arrow-icon" :class="{'open': showCompanyOfficials}">&#x25BC;</span>
              <hr>
            </div>
            <div v-if="showCompanyOfficials">
              <table>
                <thead>
                <tr>
                  <th>Firma Yetkilisi Adı Soyadı</th>
                  <th>Firma Yetkili E-Posta</th>
                  <th>Firma Yetkili Telefon</th>
                  <th>Firma Yetkili Görev&Ünvan</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(official, index) in companiesData.companyOfficials" :key="'official-' + index">
                  <td>{{ official.nameSurname || 'Bilgi Yok' }}</td>
                  <td>{{ official.email || 'Bilgi Yok' }}</td>
                  <td>{{ official.phoneNumber || 'Bilgi Yok' }}</td>
                  <td>{{ official.jobTitle || 'Bilgi Yok' }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div v-else>
          <p>Firma bilgileri yüklenemedi.</p>
        </div>
      </div>
    </div>

    <!-- Sözleşme Bilgileri -->
    <div class="company-details-container">
      <div class="company-details-header">
        <h1>Sözleşme Bilgileri</h1>
        <span @click="toggleContractInfo" class="arrow-icon" :class="{'open': showContractInfo}">&#x25BC;</span>
        <hr>
      </div>
      <div v-if="showContractInfo">
        <!-- Aktif Sözleşmeler -->
        <h2>Aktif Sözleşmeler</h2>
        <div class="table-responsive">
          <table v-if="activeContracts.length">
            <thead>
            <tr>
              <th>Sözleşme Adı</th>
              <th>Sözleşme Numarası</th>
              <th>Sözleşme Süresi (Ay)</th>
              <th>Sözleşme Başlangıç Tarihi</th>
              <th>Sözleşme Yenilenme Tarihi</th>
              <th>Kalan Süre</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="contract in activeContracts" :key="contract.id">
              <td>{{ contract.contractName }}</td>
              <td>{{ contract.contractNumber }}</td>
              <td>{{ contract.contractTime }} Ay</td>
              <td>{{ formatDate(contract.contractDate) }}</td>
              <td>{{ formatDate(contract.renewalContractDate) }}</td>
              <td>{{ calculateRemainingDays(contract.renewalContractDate) }}</td>
            </tr>
            </tbody>
          </table>
          <p v-else>Aktif sözleşme bulunmamaktadır.</p>
        </div>

        <!-- Pasif Sözleşmeler -->
        <h2 class="mt-4">Pasif Sözleşmeler</h2>
        <div class="table-responsive">
          <table v-if="inactiveContracts.length">
            <thead>
            <tr>
              <th>Sözleşme Adı</th>
              <th>Sözleşme Numarası</th>
              <th>Sözleşme Süresi (Ay)</th>
              <th>Sözleşme Başlangıç Tarihi</th>
              <th>Sözleşme Yenilenme Tarihi</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="contract in inactiveContracts" :key="contract.id">
              <td>{{ contract.contractName }}</td>
              <td>{{ contract.contractNumber }}</td>
              <td>{{ contract.contractTime }} Ay</td>
              <td>{{ formatDate(contract.contractDate) }}</td>
              <td>{{ formatDate(contract.renewalContractDate) }}</td>
            </tr>
            </tbody>
          </table>
          <p v-else>Pasif sözleşme bulunmamaktadır.</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import apiClient from "@/axios";

export default {
  name: "CompaniesDetails",
  data() {
    return {
      companiesData: null,
      showCompanyInfo: true,
      showCompanyOfficials: false,
      showContractInfo: false,
    };
  },
  created() {
    this.getCompaniesData();
  },
  computed: {
    activeContracts() {
      if (!this.companiesData?.contracts) return [];
      return this.companiesData.contracts.filter(contract =>
          new Date(contract.renewalContractDate) > new Date()
      );
    },
    inactiveContracts() {
      if (!this.companiesData?.contracts) return [];
      return this.companiesData.contracts.filter(contract =>
          new Date(contract.renewalContractDate) <= new Date()
      );
    }
  },
  methods: {
    calculateRemainingDays(renewalDate) {
      if (!renewalDate) return "Bilinmiyor";
      const today = new Date();
      const renewal = new Date(renewalDate);

      if (renewal < today) return "Sözleşme süresi dolmuş";

      let years = renewal.getFullYear() - today.getFullYear();
      let months = renewal.getMonth() - today.getMonth();
      let days = renewal.getDate() - today.getDate();

      // Adjust the months and days if the day or month difference is negative
      if (days < 0) {
        months -= 1;
        days += new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate(); // Get the number of days in the previous month
      }

      if (months < 0) {
        years -= 1;
        months += 12;
      }

      return `${years} yıl ${months} ay ${days} gün`;
    },
    formatDate(timestamp) {
      if (!timestamp) return "Bilgi Yok";
      const date = new Date(timestamp);
      return date.toLocaleDateString("tr-TR");
    },
    getContractStatus(renewalDate) {
      if (!renewalDate) return "Bilinmiyor";
      return new Date(renewalDate) > new Date() ? "Aktif" : "Pasif";
    },
    getContractStatusClass(renewalDate) {
      return new Date(renewalDate) > new Date() ? "active-status" : "inactive-status";
    },
    getCompaniesData() {
      const companyId = this.$route.params.id;
      apiClient.get(`companies/${companyId}`).then((res) => {
        this.companiesData = res.data;
      }).catch((error) => {
        console.error("Şirket verisi alınırken hata oluştu:", error);
        this.companiesData = {};
      });
    },
    toggleCompanyInfo() {
      this.showCompanyInfo = !this.showCompanyInfo;
    },
    toggleCompanyOfficials() {
      this.showCompanyOfficials = !this.showCompanyOfficials;
    },
    toggleContractInfo() {
      this.showContractInfo = !this.showContractInfo;
    },
  },
};
</script>

<style scoped>
.table-responsive {
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
}

th,
td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

th {
  background-color: #f4f4f4;
  font-weight: bold;
}

.company-details-container {
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
}

.company-details-header {
  text-align: left;
  margin-bottom: 20px;
}

.company-details-header h1 {
  font-size: 24px;
  color: #333;
  display: inline-block;
}

.arrow-icon {
  float: right;
  cursor: pointer;
  font-size: 24px;
  transition: transform 0.2s ease;
  color: #3498db;
}

.arrow-icon.open {
  transform: rotate(180deg);
}

.info-item {
  margin-bottom: 15px;
  font-size: 16px;
  color: #555;
}

.info-item strong {
  color: #333;
}

.active-status {
  color: green;
  font-weight: bold;
}

.inactive-status {
  color: red;
  font-weight: bold;
}

@media (max-width: 768px) {
  table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }

  th,
  td {
    font-size: 14px;
    padding: 6px;
  }
}

h2 {
  font-size: 20px;
  color: #333;
  margin: 20px 0;
}

.mt-4 {
  margin-top: 24px;
}

table {
  margin-bottom: 20px;
}
</style>
